export class SetCommonFilter {
  constructor(public payload: { id: string; enabled: boolean }) {}
}
